/**
 * Het plaatje bij de les. Het staat achter het token, dus een gewone
 * <img src> werkt niet: het wordt opgehaald als blob en getoond via een
 * tijdelijke URL, die weer vrijkomt als het scherm sluit.
 */
import { useEffect, useState } from 'react';
import { leerlingApi as api } from '../../../api/leerling';

export function useIllustratie(pad) {
  const [bron, setBron] = useState(null);

  useEffect(() => {
    if (!pad) return undefined;
    let url = null;
    let weg = false;
    api.haalIllustratie(pad)
      .then(blob => {
        if (weg) return;
        url = URL.createObjectURL(blob);
        setBron(url);
      })
      .catch(err => console.error('Fout bij laden illustratie:', err));
    return () => {
      weg = true;
      if (url) URL.revokeObjectURL(url);
    };
  }, [pad]);

  return bron;
}
